import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { routes } from '../routes';
import { useConvertPrice } from '../utils/convertPrice';
import { selectedCurrencyState } from '../store/selectedCurrencyAtom';
import { displayPrice } from '../utils/displayPrice';


function GridGallery({ title, items, setSort }) {
    const { t } = useTranslation()
    const convertPrice = useConvertPrice()
    const selectedCurrency = useRecoilValue(selectedCurrencyState)

	return (
		<>
            { title && <h3 className="text-5xl pb-12">{title}</h3>}
            {setSort && (
                <div className="flex justify-end mb-4">
                    <select className="bg-transparent font-light text-sm" defaultValue="created_at,desc" onChange={(e) => setSort(e.target.value)}>
                        <option value="created_at,desc">
                            {t('Sort by latest')}
                        </option>
                        <option value="price_eur,asc">
                            {t('Sort by price: low to high')}
                        </option>
                        <option value="price_eur,desc">
                            {t('Sort by price: high to low')}
                        </option>
                    </select>
                </div>
            )}
			<div className="grid sm:grid-cols-3 gap-8">
                {items.map(({ id, slug, title, painting_urls, price_eur, collection, discount }, index) => (
                    <Link 
                        to={routes.works.show(slug)} 
                        key={index} 
                        className="flex flex-col py-2 sm:px-2 hover:text-slate-400 duration-200 transition"
                    >
                        <div className="h-4/5 flex justify-center items-center sm:px-4">
                            <div className="max-w-full max-h-80 flex justify-center items-center">
                                <img 
                                    className="bg-white shadow-lg max-w-full max-h-80 object-contain opacity-0 transition-opacity duration-500 ease-in-out" 
                                    src={painting_urls?.[0][1]} 
                                    alt={title} 
                                    style={{ animation: 'fadeIn 0.5s forwards', animationDelay: `${index * 0.1}s` }} 
                                />
                            </div>
                        </div>
                        <div className="h-1/5 flex flex-col w-full items-center justify-center gap-1 mt-4">
                            <span className="font-thin text-sm text-slate-400">{collection?.title}</span>
                            <span className="font-semibold">{title}</span>
                            <span>
                                {displayPrice(price_eur, discount, convertPrice, selectedCurrency)}
                            </span>
                        </div>
                    </Link>
                ))}
			</div>
		</>
	)
}

export default GridGallery
